var _defs, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInnovation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.903,
    cy: 64.482,
    rx: 16.463,
    ry: 1.829,
    stroke: "#050505"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.902,
    cy: 45.274,
    rx: 30.64,
    ry: 2.744,
    stroke: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.805 26.067c0 1.515-19.656 2.744-43.903 2.744C20.656 28.811 1 27.582 1 26.067c0-1.515 19.656-2.744 43.902-2.744 24.247 0 43.903 1.229 43.903 2.744z",
    stroke: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.408 37.042l4.116 3.202 4.116-3.202",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.523.457v39.787",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.166 37.042l4.116 3.202 4.116-3.202",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.281.457v39.787",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.543 17.378l4.116 3.201 4.116-3.201",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.658.457V20.58",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03 16.92l4.115 3.202 4.116-3.201",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.145 0v20.122",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.785 71.799l4.116 3.2 4.116-3.2",
    stroke: "#03BCAA",
    strokeMiterlimit: 2.613
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9.457V75",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.366 64.482c0 1.01-7.37 1.829-16.463 1.829s-16.463-.819-16.463-1.83M75.542 45.274c0 1.516-13.718 2.744-30.64 2.744s-30.64-1.228-30.64-2.744M88.805 26.067c0 1.515-19.656 2.744-43.903 2.744C20.656 28.811 1 27.582 1 26.067",
    stroke: "#050505"
  })));
}

var MemoSvgInnovation = /*#__PURE__*/React.memo(SvgInnovation);
export default "data:image/svg+xml;base64,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";
export { MemoSvgInnovation as ReactComponent };